import Icon from '../../components/Icon';
import './users.css';
import { useEffect, useState } from 'react';
import { get } from '../../services/api';
import { useUI } from '../../UIContext';
import { handleErr, paginationPageSize } from '../../utils/functions';
import { useNavigate } from 'react-router-dom';
import ListPage from '../../components/ListPage';

function Users() {
    const amountByPage = paginationPageSize();
    const page = 1;
    
    const { setMessage, setLoading, loading } = useUI();
    const [users, setUsers] = useState([]);
    const [usersFiltered, setUsersFiltered] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [pageSize, setPageSize] = useState(amountByPage);
    const [pageTotal, setPageTotal] = useState(0);
    const navigate = useNavigate();

    function onClickUpdateUser(userId) {
        navigate(`/users/update/${userId}`);
    }

    const tableCols = [
        {
            dataIndex: 'fullName',
            title: 'Usuário',
            render: (value, row) => (
                <div className='user-table-data'>
                    <span>{value}</span>
                    <span>{row.email}</span>
                </div>
            )
        },
        {
            dataIndex: 'active',
            title: 'Status',
            width: '100px',
            render: (value) => (
                <span className={value ? 'tag-active' : 'tag-inactive'}>{value ? 'Ativo' : 'Inativo'}</span>
            )
        },
        {
            title: 'Ações',
            width: '120px',
            render: (_, row) => (
                <button onClick={() => onClickUpdateUser(row.id)} className='border-button edit-button glass-button-effect-15'>
                    <Icon iconClass='icon-pencil' size={16} />
                    Editar
                </button>
            )
        }
    ];

    useEffect(() => {
        async function getUsers() {
            setLoading(true);

            await get('/user/all', true, setMessage,
                (response) => {
                    const usersReturned = response.data;

                    setPageTotal(usersReturned.length);
                    setUsers(usersReturned);
                },
                (err) => {
                    handleErr(setMessage, `Falha ao obter os utilizadores: ${err}`);
                },
                () => {
                    setLoading(false);
                }
            )
        }

        getUsers();
    }, [setUsers, setMessage, setLoading]);

    useEffect(() => {
        if (!users || users.length === 0) {
            setUsersFiltered([]);
            setPageTotal(0);
            return;
        }

        const startIndex = (page - 1) * pageSize;
        const endIndex = startIndex + pageSize;

        const usersFound = users?.filter(user => 
            user.name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
            user.lastName?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
            user.email?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
            user.person?.documentNumber?.includes(searchTerm)
        );

        setPageTotal(usersFound.length);
        setUsersFiltered(usersFound.slice(startIndex, endIndex));

    }, [searchTerm, page, pageSize, users]);

    if (loading)
        return;

    return (
        <ListPage
            title='Gestão de Usuários'
            addButtonTitle='Novo usuário'
            onClickAddButton={() => navigate('/users/create')}
            onChangeSearch={(e) => setSearchTerm(e.target.value)}
            tableCols={tableCols}
            dataFiltered={usersFiltered}
            tablePageTotal={pageTotal}
            onChangeTablePage={() => { setPageSize(pageSize + amountByPage) }}
        />
    );
}

export default Users;